module.exports = __webpack_public_path__ + "static/media/image150.c84b83f8.png";